import Vue from 'vue';
import CartButton from '@/../vue/cart/CartButton.vue';
import CartFoldout from '@/../vue/cart/CartFoldout.vue';
import CartStickyBar from '@/../vue/cart/CartStickyBar.vue';
import * as track from '@/../vue/cart/tracking.js';

export const getCartData = () => {
    let qjCartData = window.localStorage.getItem('vuex');
    qjCartData = JSON.parse(qjCartData);
    if (!qjCartData) return;

    const now = new Date().getTime();
    const expired = now - qjCartData.setupTime > qjCartData.expiryPeriodDays * 24 * 60 * 60 * 1000;
    if (
        expired ||
        !qjCartData.cartWithInfo ||
        qjCartData.cart?.total === 0 ||
        !qjCartData.quote?.id
    ) {
        localStorage.removeItem('vuex');
        return;
    }
    return qjCartData;
};

const cartData = getCartData();
if (cartData) {
    document.body.classList.add('cart-active');
    const cartFoldouts = Array.from(document.querySelectorAll('.vue-cart-foldout'));
    const cartButtons = Array.from(document.querySelectorAll('.vue-cart-button'));
    const cartStickyBars = Array.from(document.querySelectorAll('.vue-cart-sticky-bar'));
    const cartLinks = Array.from(document.querySelectorAll('.js-cart-link'));

    cartLinks.forEach((el) => {
        const url = '/quote/products/hospital?quoteId=' + cartData.quote.id;
        el.href = url;
        if (el.classList.contains('NavDesk__cart-button')) {
            el.addEventListener('click', () => {
                track.continueButtonClick(el.innerText, url);
            });
        }
    });

    const props = {
        cartItems: cartData.cartWithInfo,
        total: cartData.cart.total,
        quoteId: cartData.quote.id
    };

    cartFoldouts.forEach((cart) => {
        new Vue({
            el: cart,
            render: (h) => {
                return h(CartFoldout, {
                    props: {
                        ...props,
                        promptText: cart.dataset.promptText
                    }
                });
            }
        });
    });

    cartButtons.forEach((cart) => {
        new Vue({
            el: cart,
            render: (h) => {
                return h(CartButton, { props });
            }
        });
    });

    cartStickyBars.forEach((cart) => {
        new Vue({
            el: cart,
            render: (h) => {
                return h(CartStickyBar, {
                    props: {
                        ...props,
                        promptText: cart.dataset.promptText
                    }
                });
            }
        });
    });
}
